import { useMutation } from '@tanstack/react-query';
import { sendOtp } from 'networking/mindfeed/services/auth.service';

type Variables = {
  destination: string;
  metadata?: { name: string; locale: string };
};

const useSendOtp = () => {
  return useMutation<void, Error, Variables>({
    mutationFn: (variables) => sendOtp(variables),
  });
};

export default useSendOtp;
